import { useEffect, useState } from 'react';

// useMediaQuery — true while the given CSS media query matches the
// current viewport. Updates on resize/orientation change. SSR-safe in the
// sense that it returns `false` before mount; Vite is SPA so this only
// matters for the initial render flicker, which we accept (the alternative
// is reading window.matchMedia synchronously before useEffect, which we
// do via the lazy initialiser).
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (event: MediaQueryListEvent) => setMatches(event.matches);
    // Sync once in case the value changed between initial render and effect.
    setMatches(mql.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}
